import { EuiHealth } from '@elastic/eui';
import React, { useEffect, useState } from 'react';
import SelectorSimple from '../../../../../shared/Components/Selectores/Simple';


export const SelectorTipoImportacionCG = (props:any) =>{

  let {data, onChange, valueOfSelected} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    //if(data)
    {setOptions(getOptions())}
  },[])

  useEffect(()=>{
    if(valueOfSelected===undefined && options!==undefined){ change(options[0]&&options[0].value)}
  },[options&&options.length])

  const STATE = {
    cto218: 'Area 218',
    cto221: 'Area 221',
    cto286: 'Area 286',
    centrosCorporativos: 'Centros Corporativos',
    todo: 'Todo'
  }
 
  const getOptions = () =>{
      return [
        { value: -1, inputDisplay: STATE.todo },
        { value: 1, inputDisplay: STATE.cto218 },
        { value: 2, inputDisplay: STATE.cto221 },
        { value: 4, inputDisplay: STATE.cto286 },
        { value: 3, inputDisplay: STATE.centrosCorporativos }
      ]
  }

  const change = (value:any) =>{
    onChange(value)
  }

  return (
    <SelectorSimple {...props} options={options} onChange={change} name="selectTipoImportacionCG"/>
  )
}
export default SelectorTipoImportacionCG